export default {
  namespaced: true,
  state: {
    processFilter: [],
    companyFilter: [],
    idFilter: [],
    crimeFilter: [],
    controlFilter: [],
    processResponsibleFilter: [],
    // Puedes agregar otros filtros aquí en el futuro si necesitas que sean globales
    // locationFilter: [],
    // roleFilter: [],
    // etc.
  },
  getters: {
    getProcessFilter: state => state.processFilter,
    getCompanyFilter: state => state.companyFilter,
    getIdFilter: state => state.idFilter,
    getCrimeFilter: state => state.crimeFilter,
    getControlFilter: state => state.controlFilter,
    getProcessResponsibleFilter: state => state.processResponsibleFilter,
  },
  mutations: {
    SET_PROCESS_FILTER(state, value) {
      state.processFilter = value
    },
    RESET_PROCESS_FILTER(state) {
      state.processFilter = []
    },
    SET_COMPANY_FILTER(state, value) {
      state.companyFilter = value
    },
    RESET_COMPANY_FILTER(state) {
      state.companyFilter = []
    },
    SET_ID_FILTER(state, value) {
      state.idFilter = value
    },
    RESET_ID_FILTER(state) {
      state.idFilter = []
    },
    SET_CRIME_FILTER(state, value) {
      state.crimeFilter = value
    },
    RESET_CRIME_FILTER(state) {
      state.crimeFilter = []
    },
    SET_CONTROL_FILTER(state, value) {
      state.controlFilter = value
    },
    RESET_CONTROL_FILTER(state) {
      state.controlFilter = []
    },
    SET_PROCESS_RESPONSIBLE_FILTER(state, value) {
      state.processResponsibleFilter = value
    },
    RESET_PROCESS_RESPONSIBLE_FILTER(state) {
      state.processResponsibleFilter = []
    },
  },
  actions: {
    setProcessFilter({ commit }, value) {
      commit('SET_PROCESS_FILTER', value)
    },
    resetProcessFilter({ commit }) {
      commit('RESET_PROCESS_FILTER')
    },
    setCompanyFilter({ commit }, value) {
      commit('SET_COMPANY_FILTER', value)
    },
    resetCompanyFilter({ commit }) {
      commit('RESET_COMPANY_FILTER')
    },
    setIdFilter({ commit }, value) {
      commit('SET_ID_FILTER', value)
    },
    resetIdFilter({ commit }) {
      commit('RESET_ID_FILTER')
    },
    setCrimeFilter({ commit }, value) {
      commit('SET_CRIME_FILTER', value)
    },
    resetCrimeFilter({ commit }) {
      commit('RESET_CRIME_FILTER')
    },
    setControlFilter({ commit }, value) {
      commit('SET_CONTROL_FILTER', value)
    },
    resetControlFilter({ commit }) {
      commit('RESET_CONTROL_FILTER')
    },
    setProcessResponsibleFilter({ commit }, value) {
      commit('SET_PROCESS_RESPONSIBLE_FILTER', value)
    },
    resetProcessResponsibleFilter({ commit }) {
      commit('RESET_PROCESS_RESPONSIBLE_FILTER')
    },
  },
}
